import { commonApi } from '@common/utils/baseQuery';
import type { IEngagementTaskResponse } from './engagement.type';

export const engagementApi = commonApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchEngagementTasks: builder.query<IEngagementTaskResponse[], void>({
      query: () => '/engagement/tasks',
    }),
  }),
});

export const {
  useFetchEngagementTasksQuery,
} = engagementApi;
